module.exports = __webpack_public_path__ + "img/shuxian11.34b6c496.png";